import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { TRF_REPORT_BASE_PATH } from '../../../../../../../../../features/trf/report/trf-report-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-report/_trf-report')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'trf-report-list',
        label: 'Trades',
        to: TRF_REPORT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
